module.exports = __webpack_public_path__ + "img/header_logo.07bc9425.png";